import React from 'react';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
interface IServiceWorkerWrapper {
  serviceWorkerRegistration: ServiceWorkerRegistration
}

const NewVersionAvailableAlertMessage: React.FunctionComponent<IServiceWorkerWrapper> = ({ serviceWorkerRegistration }) => {
  const handleRefresh = () => {
    const registrationWaiting = serviceWorkerRegistration.waiting;
    if (registrationWaiting) {
      registrationWaiting.postMessage({ type: "SKIP_WAITING" });
      registrationWaiting.addEventListener("statechange", ({ target }: any) => {
        if (target?.state === "activated") {
          window.location.reload();
        }
      });
    }
  }

  return (
    <Alert
      severity="warning"
      action={<ActionButton onClick={handleRefresh} />}
    >
      Une nouvelle version est disponible
    </Alert>
  );
}

const ActionButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    color="inherit"
    size="small"
    onClick={onClick}
  >
    Mettre à jour
  </Button>
)

export default NewVersionAvailableAlertMessage;